import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-search',
  templateUrl: './icon-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSearchComponent {}
